import { required, array, optional } from 'AppReact/schema';

export const inspection_tag = {
  name: required('string'),
  color: required('string'),
  priority_id: optional('integer'),
  id: optional('integer'),
  property_ids: array('integer'),
  group_ids: array('integer'),
  is_active: optional('boolean'),
  auto_add_new_properties: optional('boolean'),
}